/**
 * @type {BD_CFG}
 */
const CONFIG = {
    ajaxURL: window.CFG?.ajaxURL ?? "",
    restURL: window.CFG?.restURL ?? "",
    themeURL: window.CFG?.themeURL ?? "",
    homeURL: window.CFG?.homeURL ?? "",
    siteURL: window.CFG?.siteURL ?? "",
    user: window.CFG?.user ?? {
        id: window.CFG?.user?.id ?? 0,
    },
    game: window.CFG?.game ?? {
        pages: window.CFG?.game?.pages ?? [],
        current_page: window.CFG?.game?.current_page ?? "",
        qrLogoURL: window.CFG?.game?.qrLogoURL ?? "",
        avatarPlaceholderURL: window.CFG?.game?.avatarPlaceholderURL ?? "",
        isProfileCreated: window.CFG?.game?.isProfileCreated ?? false,
        departments: window.CFG?.game?.departments ?? [],
        main_departments: window.CFG?.game?.main_departments ?? [],
        rarity_levels: window.CFG?.game?.rarity_levels ?? [],
        qr_code_mode: window.CFG?.game?.qr_code_mode ?? "static",
        qr_code_expiry_ms: window.CFG?.game?.qr_code_expiry_ms ?? null,
    },
    isAuth: window.CFG?.isAuth ?? 0,
    isIntroCompleted: window.CFG?.isIntroCompleted ?? 0,
    nonce: window.CFG?.nonce ?? "",
};

export default CONFIG;
